<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">소켓</div>
      <el-button class="mr-l4" size="mini" @click="loadData"><i class="far fa-sync-alt"/></el-button>
    </div>
    <div>
      <el-button size="small" @click="exportSocketInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="tableData" :column-default="columnDefault" v-loading="isLoading" :columns="columns" :defaultSort="defaultSortCol"
  :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    <template slot-scope="scope" slot="detail-slot">
      <span v-if="existStack(scope.row)" class="c-pointer"><i class="far fa-search-plus" @click="showStackPopup(scope.row)"/></span>
    </template>
  </el-table-wrapper>
  <w-socket-stack-trace-popup ref="socketStackTracePopup" :socketInfo="socketInfo"></w-socket-stack-trace-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, cloneDeep, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import ApmConfigAPI from '@/api/config/apm/apm-info';
import FileApi from '@/api/common/file';
import WSocketStackTracePopup from './popup/SocketStackTracePopup';

export default {
  name: 'WSocketInfoNode',
  components: {
    WSocketStackTracePopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      tableData: [],
      defaultSortCol: { prop: 'count', order: 'descending' },
      showSearchTool: false,
      socketInfo: {},
      isLoading: false,
      params: {
        objId: null,
      },
      columns: [
        {
          prop: 'host',
          label: '호스트',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'port',
          label: '포트',
          width: 200,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'portText',
          label: '포트 이름',
          width: 200,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serviceText',
          label: '서비스',
          width: 350,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'count',
          label: '호출 (건)',
          width: 150,
          sortable: true,
          searchable: true,
          formatter: this.convertCountValue,
        },
        {
          label: '상세보기',
          width: 80,
          scopedSlot: 'detail-slot',
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WSocketInfoNode') {
          this.initData();
          this.loadData();
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WSocketInfoNode') {
          this.initData();
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.tableData = [];
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadData() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      ApmConfigAPI.getSocketList({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          if (Object.entries(response.data.data).length > 0) {
            this.tableData = response.data.data.values;
          } else {
            this.tableData = [];
          }
        }
        this.isLoading = false;
      });
    },
    convertCountValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'count', true, false, true);
    },
    existStack(row) {
      if (row.stack.length > 0) {
        return true;
      }
      return false;
    },
    showStackPopup(row) {
      this.socketInfo = cloneDeep(row);
      this.$refs.socketStackTracePopup.open();
    },
    exportSocketInfo() {
      if (!isNil(this.selectedNode)) {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        ApmConfigAPI.getSocketExcelName(params).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/socket/index.vue